import TruckMoving from '../../src/legacy/TruckMoving';
export default TruckMoving;
